import React from 'react';
import DaTable from './../../../common/DaTable'
import DatePicker from 'react-datepicker';
import Panel from '../../../common/layout/Panel'
import Modal from 'react-bootstrap-modal';
import Button from '../../../common/Button';
var imm = require('immutable');


export default class extends React.Component {
    constructor (props) {
        const accountId = props.match.params.account_id;
        super(props)
        this.state = {
            url: `/admin/clients/accounts/${accountId}/invoices`,
            limit: 50,
            offset: 0,
            datalen: 0,
            data: [],
            loading: false,
            daterange: imm.Map({
                from: new Date(new Date().getFullYear(), new Date().getMonth(), 1), 
                to: new Date()
            }),
            metadata:
                [
                    {
                        label: 'ID',
                        source: 'ATRINVID',
                        type: 'primary',
                        visible: false
                    },
                    {
                        label: 'Number',
                        source: 'ATRINVNUMBER',
                        type: 'text',
                    },
                    {
                        label: 'Created Date',
                        source: 'ATRINVCREATE',
                        type: 'datetime',
                    },
                    {
                        label: 'Period Start',
                        source: 'ATRINVSTDT',
                        type: 'datetime',
                    },
                    {
                        label: 'Period End',
                        source: 'ATRINVENDT',
                        type: 'datetime',
                    },
                    {
                        label: 'Amount',
                        source: 'ATRINVTOTAL',
                        type: 'text'
                    },
                    {
                        label: 'View',
                        value: '/reports/invoices/{$id}',
                        type: 'link'
                    },
                ]
        }
    }
    componentDidMount(){
        this.loadFromServer();
    }
    loadFromServer() {
        this.setState({loading: true});
        const filter = {
            from: this.state.daterange.get('from').valueOf()/1000,
            to: this.state.daterange.get('to').valueOf()/1000
        }
        let params = {};
        params.filter = filter;
        params.pagination = {page: this.state.offset/this.state.limit+1, perPage: this.state.limit }
        this.props.childProps.dataProvider.getList(this.state.url, params, this.props).then(
            response => {
                if (response.data !== undefined) {
                    this.setState({
                        data: response.data,
                        datalen: response.data.length,
                        loading: false
                    })
                } 
            }
        );
    }
    onLoadMore() {
        var offset = this.state.offset + this.state.limit;
        this.setState({
                offset: offset
            }, function () {
                this.loadFromServer()
            }
        );
    }
    handleDateChange(key, value) {
        this.setState((state) => ({
            daterange: state.daterange.set(key, value)
        }));
    }
    handleFilter() {
        this.loadFromServer();
    }
    onRowAdded() {
        this.loadFromServer();
    }
    render(){
        return(
            <Panel title = "Invoices">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="panel panel-default">
                                    <div className="panel-body">
                                        <form className="form-horizontal">
                                            <div className="row">
                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <div className='form-group'>
                                                        <label className="col-sm-2 control-label">from</label>
                                                        <div className="col-sm-4 input-group">
                                                            <DatePicker
                                                                className="form-control datepicker"
                                                                selected={ new Date(this.state.daterange.get('from')) }
                                                                onChange={ this.handleDateChange.bind(this, 'from') }
                                                                timeFormat="HH:mm"
                                                                dateFormat="yyyy-MM-dd"
                                                            />
                                                        </div>
                                                        <label className="col-sm-2 control-label">to</label>
                                                        <div className="col-sm-4 input-group">
                                                            <DatePicker
                                                                className="form-control datepicker"
                                                                selected={ new Date(this.state.daterange.get('to')) }
                                                                onChange={ this.handleDateChange.bind(this, 'to') }
                                                                showTimeSelect
                                                                dateFormat="yyyy-MM-dd"
                                                            />
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <Button bsStyle="save" value="Filter" onClick={this.handleFilter.bind(this)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <ModalBody
                                    bsStyle="add"
                                    addButton="true"
                                    addButtonValue="Create Invoice"
                                    metadata={this.state.metadata}
                                    url={this.state.url}
                                    urlattrs={this.props.urlattrs}
                                    remotemeta={this.state.data.metadata}
                                    onRowAdded={this.onRowAdded.bind(this)}
                                    {...this.props}
                                    account_id = {this.props.match.params.account_id}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <DaTable
                                    data={this.state.data}
                                    metadata={this.state.metadata}
                                    url={this.state.url}
                                    urlattrs={this.props.urlattrs}
                                    onLoadMore = { this.onLoadMore }
                                    datalen = { this.state.datalen }
                                    limit = { this.state.limit }
                                    offset = { this.state.offset }
                                    loadMore = { false }
                                    footer = { this.state.data.totals }
                                    loading = { this.state.loading }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Panel>
        )
    }
}

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
    }
};

class ModalBody extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            modalIsOpen: false,
            showPreviewTable: false,
            errors: [],
            data: imm.Map({
                from:  new Date(new Date().getFullYear(), new Date().getMonth()-1, 1),
                to: new Date(new Date().getFullYear(), new Date().getMonth(), 0)
            }),
            options: imm.Map(),  // for select fields
            defaults: imm.Map({
                    from:  new Date(new Date().getFullYear(), new Date().getMonth()-1, 1),
                    to: new Date(new Date().getFullYear(), new Date().getMonth(), 0)
            }), 
            fields: [],
            remotemeta: [],
            errorfields: [],
            errormsg: '',
            sms_totals: [],
            voice_totals: {subtotals: []},
            sms_did_rec: [],
            serv_fees: [],
            totals: [],
            previewed: false
        }
    }
    handleCancel() {
     //   this.prepareRemoteData();
        this.setState({
            modalIsOpen: false,
            data: this.state.defaults,
            errorfields: [],
            previewed: false
        });
    }
    handleClick() {
      //  this.prepareRemoteData();
        this.setState({modalIsOpen: true});
    }
    handleDateChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }));
    }
    onRowAdded() {
        this.props.onRowAdded();
    }
    handlePreview() {
        const filter = {
            from: this.state.data.get('from').valueOf()/1000 - new Date().getTimezoneOffset() * 60,
            to: this.state.data.get('to').valueOf()/1000 - new Date().getTimezoneOffset() * 60
        }
        let params = {};
        params.filter = filter;
        const url = `/admin/clients/accounts/${this.props.account_id}/invoices/preview`;
        this.props.childProps.dataProvider.getList(url, params, this.props).then(
            response => {
                if (response.data !== undefined) {
                    this.setState({
                        totals: response.data.totals,
                        voice_totals: response.data.voice_totals,
                        sms_totals: response.data.sms_totals,
                        sms_did_rec: response.data.sms_did_rec,
                        serv_fees: response.data.serv_fees,
                        showPreviewTable: true,
                        previewed: true
                    })
                } 
            }
        );
    }
    handleSave(e) {
        this.setState({errorfields: [], errormsg: ''});
        const params = {
            data: {
                totals: this.state.totals,
                sms_totals: this.state.sms_totals,
                voice_totals: this.state.voice_totals,
                sms_did_rec: this.state.sms_did_rec,
                serv_fees: this.state.serv_fees
            }
        };
        const url = `/admin/clients/accounts/${this.props.account_id}/invoices`;
        this.props.childProps.dataProvider.create(url, params, this.props).then(
            response => {
                this.props.onRowAdded(response.data);
                this.setState({
                    data: this.state.defaults,
                    modalIsOpen: false
                });
            }
        );
    }
    render() {
        var addButton;
        var buttonValue = "Add New";
        if (this.props.addButtonValue) {
            var buttonValue = this.props.addButtonValue;
        }
        if (this.props.addButton) {
            addButton = <Button bsStyle={ this.props.bsStyle ? this.props.bsStyle: "default"} value={buttonValue} onClick={this.handleClick.bind(this)}/>
        }
        if (this.props.metadata == undefined)
            return null;
        const {previewed} = this.state;
        return(
            <div>
                {addButton}
                <Modal show={this.state.modalIsOpen} onHide={this.handleCancel.bind(this)} style={customStyles}>
                    <Modal.Header closeButton>
                        <Modal.Title>Create New Invoice</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form className="form-horizontal">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <label
                                            className="col-sm-4 control-label"
                                            htmlFor="from">Start Date</label>
                                        <div className="col-sm-8">
                                            <DatePicker
                                                selected={ new Date(this.state.data.get('from')) }
                                                onChange={ this.handleDateChange.bind(this, 'from') }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label
                                            className="col-sm-4 control-label"
                                            htmlFor="from">End Date</label>
                                        <div className="col-sm-8">
                                            <DatePicker
                                                selected={ new Date(this.state.data.get('to')) }
                                                onChange={ this.handleDateChange.bind(this, 'to') }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-sm-4"></div>
                                        <div className="col-sm-8">
                                            <Button bsStyle="save" value="Calculate & Preview" onClick={this.handlePreview.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <PreviewSummaryTable totals = {this.state.totals} show = {this.state.showPreviewTable} />
                            <PreviewVoiceTable voice_totals = {this.state.voice_totals} show = {this.state.showPreviewTable} />
                            <PreviewSmsTable sms_totals = {this.state.sms_totals} show = {this.state.showPreviewTable} />
                            <PreviewSmsDidRecTable sms_did_rec = {this.state.sms_did_rec} show = {this.state.showPreviewTable} />
                            <PreviewServiceFeesTable serv_fees = {this.state.serv_fees} show={this.state.showPreviewTable} />
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <div>
                            <Button bsStyle="cancel" value="Cancel" onClick={this.handleCancel.bind(this)}/>
                            {previewed && <Button bsStyle="save" value="Save & Create Invoice" onClick={this.handleSave.bind(this)}/>}
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }

}

class PreviewServiceFeesTable extends React.Component {
    render(){
        if (!this.props.show)
            return null;
        if (!this.props.serv_fees)
            return null;
        var serv_fees = this.props.serv_fees;
        return (
            <div className="row">
                <div className="col-lg-12">
                    <h4>Other Fees</h4>
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Amount</th>
                            <th>Currency</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.props.serv_fees.map(function(datarow, j) {
                                return (
                                    <tr key = {j}>
                                        <td>{datarow.name}</td>
                                        <td>{datarow.amount}</td>
                                        <td>{datarow.currency}</td>
                                    </tr>)
                            }, this)
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

class PreviewSmsDidRecTable extends React.Component {
    render(){
        if (!this.props.show)
            return null;
        if (!this.props.sms_did_rec)
            return null;
        var sms_did_rec = this.props.sms_did_rec;
        return (
            <div className="row">
                <div className="col-lg-12">
                    <h4>SMS DID Recurring Fees</h4>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Count</th>
                                <th>DID Number</th>
                                <th>Amount</th>
                                <th>Currency</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            this.props.sms_did_rec.map(function(datarow, j) {
                                return (
                                    <tr key = {j}>
                                        <td>{datarow.COUNT}</td>
                                        <td>{datarow.ATRDIDNUMBER}</td>
                                        <td>{datarow.AMOUNT}</td>
                                        <td>{datarow.CURRENCY}</td>
                                    </tr>)
                            }, this)
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

class PreviewVoiceTable extends React.Component {
    render() {
        if (!this.props.show)
            return null;
        if (!this.props.voice_totals)
            return null;
        var voice_totals = this.props.voice_totals;

        return (
            <div className="row">
                <div className="col-lg-12">
                    <h4>Voice Usage</h4>
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <th>Destination</th>
                            <th>Calls</th>
                            <th>Minutes</th>
                            <th>Amount</th>
                            <th>Currency</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.props.voice_totals.subtotals.map(function(datarow, j) {
                                var destname = datarow.ATRCLIENTDESTNAME || 'Unidentified'
                                return (
                                    <tr key = {j}>
                                        <td>{destname}</td>
                                        <td>{datarow.CALLS}</td>
                                        <td>{datarow.SECONDS}</td>
                                        <td>{datarow.AMOUNT}</td>
                                        <td>{datarow.CURRENCY}</td>
                                    </tr>)
                            }, this)
                        }
                        </tbody>
                        <tfoot>
                        <tr>
                            <td>Total</td>
                            <td>{voice_totals.grand_total.CALLS}</td>
                            <td>{voice_totals.grand_total.SECONDS}</td>
                            <td>{voice_totals.grand_total.AMOUNT}</td>
                            <td>{voice_totals.grand_total.CURRENCY}</td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

        )
    }
}


class PreviewSmsTable extends React.Component {
    render(){
        if (!this.props.show)
            return null;
        if (!this.props.sms_totals)
            return null;
        var sms_totals = this.props.sms_totals;


        return (
            <div className="row">
                <div className="col-lg-12">
                    <h4>SMS Usage</h4>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Direction</th>
                                <th>Destination</th>
                                <th>Messages</th>
                                <th>Msg parts</th>
                                <th>Amount</th>
                                <th>Currency</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            this.props.sms_totals.subtotals.map(function(datarow, j) {
                                var destname = datarow.ATRCLIENTDESTNAME || 'Unidentified'
                                return (
                                <tr key = {j}>
                                    <td>{datarow.ATRDIRECTION}</td>
                                    <td>{destname}</td>
                                    <td>{datarow.MESSAGES}</td>
                                    <td>{datarow.MSGPARTS}</td>
                                    <td>{datarow.AMOUNT}</td>
                                    <td>{datarow.CURRENCY}</td>
                                </tr>)
                            }, this)
                        }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>Total</td>
                                <td></td>
                                <td>{sms_totals.grand_total.MESSAGES}</td>
                                <td>{sms_totals.grand_total.MSGPARTS}</td>
                                <td>{sms_totals.grand_total.AMOUNT}</td>
                                <td>{sms_totals.grand_total.CURRENCY}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

        )
    }
}

class PreviewSummaryTable extends React.Component {
    render(){
        if (!this.props.show)
            return null;
        if (!this.props.totals)
            return null;
        var totals =  this.props.totals;
        return (
            <div className="row">
                <div className="col-lg-12">
                    <h4>Summary for the Period</h4>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Summary</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Currency</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Opening Balance</td>
                                <td>{totals.from}</td>
                                <td>{totals.opening}</td>
                                <td>{totals.currency}</td>
                            </tr>
                            <tr>
                                <td>Total Consumption: VOICE</td>
                                <td></td>
                                <td>{totals.consumption_voice}</td>
                                <td>{totals.currency}</td>
                            </tr>
                            <tr>
                                <td>Total Consumption: SMS</td>
                                <td></td>
                                <td>{totals.consumption_sms}</td>
                                <td>{totals.currency}</td>
                            </tr>
                            <tr>
                                <td>Total Consumption: Recurring Fees SMS</td>
                                <td></td>
                                <td>{totals.consumption_sms_rec}</td>
                                <td>{totals.currency}</td>
                            </tr>
                            <tr>
                                <td>Discount ({totals.discount_rate} %)</td>
                                <td></td>
                                <td>{totals.discount_amount}</td>
                                <td>{totals.currency}</td>
                            </tr>
                            <tr>
                                <td>Total Payments</td>
                                <td></td>
                                <td>{totals.payments}</td>
                                <td>{totals.currency}</td>
                            </tr>
                            <tr>
                                <td>Closing Balance</td>
                                <td>{totals.to}</td>
                                <td>{totals.closing}</td>
                                <td>{totals.currency}</td>
                            </tr>
                        </tbody>
                        <tfoot>

                            <tr>
                                <td>Total Invoice</td>
                                <td></td>
                                <td>{totals.total_invoice}</td>
                                <td>{totals.currency}</td>
                            </tr>
                            <tr>
                                <td>VAT ({totals.vat_rate} %)</td>
                                <td></td>
                                <td>{totals.vat_amount}</td>
                                <td>{totals.currency}</td>
                            </tr>
                            <tr>
                                <td>Total Invoice with VAT</td>
                                <td></td>
                                <td>{totals.total_invoice_with_vat}</td>
                                <td>{totals.currency}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        )
    }
}